import apiService from './api.service';

/**
 * One request per dashboard view. The server decides which widgets this role may
 * receive, so the client never asks for individual metrics.
 */
const getDashboard = (preset) =>
  apiService.getDashboard(preset ? { preset } : {}).then((r) => r.data);

/** Remembers the switcher choice across devices. */
const saveLastDashboard = (preset) =>
  apiService.updateLastDashboard(preset).then((r) => r.data);

const dashboardService = { getDashboard, saveLastDashboard };

export default dashboardService;
